/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { parametersFilter } from '../models/parametersFilter';
import type { parametersFilterCount } from '../models/parametersFilterCount';
import type { paymentInvoice } from '../models/paymentInvoice';
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PaymentInvoicesService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * count paymentInvoices
   * Count paymentInvoices (with filtering, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any Count of paymentInvoice documents found. Wrapped in a JsonAPI root response with wrapped count result as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsPaymentInvoicesCount(
    filter?: parametersFilterCount,
  ): CancelablePromise<{
    data?: {
      count?: number;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/paymentInvoices/count',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find one paymentInvoice
   * Find one paymentInvoice by its unique identifier.
   * @param identifier paymentInvoice unique identifier
   * @returns any One paymentInvoice document found. Wrapped in a JsonAPI root response with document as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsPaymentInvoices(
    identifier: string,
  ): CancelablePromise<{
    data?: paymentInvoice;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/paymentInvoices/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find many paymentInvoices
   * Find many paymentInvoices (with filtering, projection, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * - To only return specific fields, use the projection query parameter. Usage is as follows: filter[fields][fieldName1]=true&filter[fields][fieldName2]=true.
   * @param filter
   * @returns any One or many paymentInvoice documents found. Wrapped in a JsonAPI root response with collection of documents as data.
   * @throws ApiError
   */
  public getApiServiceorganizationsPaymentInvoices1(
    filter?: parametersFilter,
  ): CancelablePromise<{
    data?: Array<paymentInvoice>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/paymentInvoices',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

}
